import CentralAuthLogin from '../components/central/authorization/IndexLogin.vue';
import CentralAuthLoginSSO from '../components/central/authorization/IndexLoginSSO.vue';
import CentralLoginSSOSuccess from '../components/central/authorization/LoginSSOSuccess.vue';
import CentralAuthRegister from '../components/central/authorization/IndexRegister.vue';
import CentralAuthForgotPassword from '../components/central/authorization/ForgotPassword.vue';
import CentralAuthChangePassword from '../components/central/authorization/ChangePassword.vue';
import CentralAuthSuccessPassword from '../components/central/authorization/SuccessPassword.vue';
import CentralAuthVerify from '../components/central/authorization/Verify.vue';
import CentralIFrame from '../components/central/authorization/IFrame.vue';
import CentralAccountStore from '../components/central/account/stores/StoreIndex.vue';
import CentralAccountProfile from '../components/central/account/profile/Index.vue';
import CentralAccountReferFriends from '../components/central/account/referfriends/ReferFriendsIndex.vue';
import CentralAccountSecurity from '../components/central/account/security/Index.vue';
import CentralAccountPageNotFound from '../components/central/account/PageNotFound.vue';
import ChangePassword from '../components/central/account/profile/ChangePassword.vue';

import PublicSocialAccountWaiting from '../components/central/public/SocialAccountWaiting';
import PublicSocialAccountCallback from '../components/central/public/SocialAccountCallback';

let CentralAuthorizationLayout = 'central-authorization-layout'
let CentralAuthorizationSSOLayout = 'central-authorization-sso-layout'
let CentralAdminLayout = 'central-admin-layout'
let CentralPublicLayout = 'central-public-layout'
import AppleAuthRedirect from '../components/central/authorization/AppleAuthRedirect.vue';

const titleSuffix = 'ระบบหลังบ้านจัดการขนส่ง';

const centralRouter = [
    {
        path: "/",
        name: "index",
        component: CentralAccountStore,
        meta: {
            layout: CentralAdminLayout,
            title: "Stores",
            suffix: titleSuffix
        }
    },
    {
        path: "/v1/auth/:provider/callback",
        name: 'SocialAccountCallback',
        component: PublicSocialAccountCallback,
        meta: {
            // layout: CentralAuthorizationLayout,
            layout: CentralPublicLayout,
            title: 'Social Login',
            suffix: titleSuffix
        }
    },
    {
        path: "/v1/auth/watiting",
        name: 'SocialAccountWaiting',
        component: PublicSocialAccountWaiting,
        meta: {
            layout: CentralPublicLayout,
            title: 'Social Watiting',
            suffix: titleSuffix
        }
    },
    {
        path: "/login",
        name: "auth.login",
        component: CentralAuthLogin,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'Login',
            suffix: 'GoShip ' + titleSuffix
        }
    },
    {
        path: "/login/apple",
        name: "auth.login.apple",
        component: AppleAuthRedirect,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'LoginApple',
            suffix: titleSuffix
        }
    },
    {
        path: "/login-sso",
        name: "auth.login.sso",
        component: CentralAuthLoginSSO,
        meta: {
            layout: CentralAuthorizationSSOLayout,
            title: 'Login',
            suffix: titleSuffix
        }
    },
    {
        path: "/sso-success",
        name: "auth.login.sso.success",
        component: CentralLoginSSOSuccess,
        meta: {
            layout: CentralAuthorizationSSOLayout,
            title: 'SSO Success',
            suffix: titleSuffix
        }
    },
    {
        path: "/register",
        name: "auth.register",
        component: CentralAuthRegister,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'Register',
            suffix: 'GoShip ' + titleSuffix
        }
    },
    {
        path: "/forgotpassword",
        name: "auth.forgotpassword",
        component: CentralAuthForgotPassword,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'Forgot Password',
            suffix: titleSuffix
        }
    },
    {
        path: "/changepassword",
        name: "auth.changepassword",
        component: CentralAuthChangePassword,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'Change Password',
            suffix: titleSuffix
        }
    },
    {
        path: "/successpassword",
        name: "auth.successpassword",
        component: CentralAuthSuccessPassword,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'Succes Password',
            suffix: titleSuffix
        }
    },
    {
        path: "/verify",
        name: "auth.verify",
        component: CentralAuthVerify,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'Verification',
            suffix: titleSuffix
        }
    },
    {
        path: "/iframe",
        name : "iframe",
        component: CentralIFrame,
        meta: {
            layout: "no-layout",
            title: 'iframe',
            suffix: titleSuffix
        }
    },
    {
        path: "/store",
        name: "account.stores",
        component: CentralAccountStore,
        meta: {
            layout: CentralAdminLayout,
            title: "Stores",
            requiresAuth: true,
            suffix: titleSuffix
        }
    },
    {
        path: "/general",
        name: "account.profile",
        component: CentralAccountProfile,
        meta: {
            layout: CentralAdminLayout,
            title: 'Account Details',
            requiresAuth: true,
            suffix: titleSuffix
        }
    },
    {
        path: "/forgot/changepassword",
        name: "account.profile.changepassword",
        component: ChangePassword,
        meta: {
            layout: CentralAuthorizationLayout,
            title: 'Change Password',
            suffix: titleSuffix
        }
    },
    {
        path: "/referfriends",
        name: "account.referfriends",
        component: CentralAccountReferFriends,
        meta: {
            layout: CentralAdminLayout,
            title: 'Refer Friends',
            requiresAuth: true,
            suffix: titleSuffix
        }
    },
    {
        path: "/security",
        name: "account.security",
        component: CentralAccountSecurity,
        meta: {
            layout: CentralAdminLayout,
            title: 'Security',
            requiresAuth: true,
            suffix: titleSuffix
        }
    },
    {
        path: "/:catchAll(.*)",
        name: "Not Found",
        component: CentralAccountPageNotFound,
        meta: {
            layout: CentralAdminLayout,
            title: 'Not found',
            requiresAuth: true,
            suffix: titleSuffix
        }
    },
]
export default centralRouter



// WEBPACK FOOTER //
// ./src/router/central.js